import wrapWithProvider from "./redux-provider";
export const wrapRootElement = wrapWithProvider;
import "@fontsource/inter";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
